/**
 * Validación esperada del picker de imágenes (tipo/peso). El caller muestra el
 * mensaje al usuario; no va a Sentry (VUELTO-NEGOCIO-3K). Vive en domain (sin
 * deps de expo) para poder testearse sin stubs de nativo.
 */
export class ProductImageValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ProductImageValidationError';
  }
}

export function isProductImageValidationError(error: unknown): error is ProductImageValidationError {
  return error instanceof ProductImageValidationError;
}
